import Button from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Container = styled.div<{
	scale: number;
	alreadyAccepted: boolean;
	$backgroundImage: string;
}>`
	padding: 0px;
	width: 21.43em;
	height: ${(props) => (props.alreadyAccepted ? "16.5em" : "23.5em")};
	position: relative;
	display: flex;
	justify-content: center;
	border-radius: 18px;
	font-size: 1rem;
	transform: scale(${(props) => props.scale});
	box-shadow: 0 0.32em 1em 0 rgba(0, 0, 0, 0.15);
	background-image: url(${(props) => props.$backgroundImage});
	background-size: cover;
	background-position: top center;
	background-repeat: no-repeat;

	// prettier-ignore
	@media (orientation: landscape) {
		width: ${(props) => (props.alreadyAccepted ? "21.43em" : "56.87em")};
		height: ${(props) => (props.alreadyAccepted ? "16.69em" : "25.69em")};
		background-position: top;
		background-size: cover; //100% 35%;
	}
`;

export const OffersContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 0.4em;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	@media (orientation: landscape) {
		gap: 1em;
		width: 90%;
	}
`;

export const Offer = styled.div`
	position: relative;
	width: 100%;

	> span {
		position: absolute;
		top: 0.45em;
		right: -0.385em;
		color: #68e12c;
		z-index: 2;
		font-family: "Baloo";
		font-size: 4.5em;
		font-style: normal;
		font-weight: 400;
		-webkit-text-stroke-width: 0.12em;
		-webkit-text-stroke-color: #fff;
		paint-order: stroke fill;
		filter: drop-shadow(0 0 0 #fff);

		@media (orientation: portrait) {
			font-size: 3.5em;
			top: 0.35em;
			right: -0.345em;
		}
	}

	@media (orientation: landscape) {
		max-width: 24em;
	}
`;

export const OfferItem = styled.div`
	position: relative;
	z-index: 1;
	grid-template-rows: auto;
	background-color: rgba(0, 0, 0, 0.25);
	backdrop-filter: blur(14px);
	border-radius: 12px;
	padding: 0.6em 0.5em;
	gap: 0.5rem;
	box-sizing: border-box;
	height: 5.75em;
	//z-index: 999;
	align-content: stretch;
	width: 100%;

	@media (orientation: landscape) {
		padding: 1.4em 1em;
		height: 7.81em;
	}
`;

export const DataContainer = styled.div`
	position: absolute;
	width: 92%;
	bottom: 0.8em;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	@media (orientation: landscape) {
		bottom: 0;
		width: 100%;
		padding: 1em 0;
		//background-color: white;
		border-bottom-left-radius: 18px;
		border-bottom-right-radius: 18px;
	}
`;

export const Items = styled.div`
	justify-content: space-evenly;
	align-items: end;
	display: flex;
	flex-wrap: nowrap;

	@media (orientation: landscape) {
		justify-content: center;
	}
`;

export const RewardItem = styled.div<{ width: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
	gap: 0.2em;
`;

export const RewardAmountContainer = styled.div``;

export const ItemImage = styled.img`
	object-fit: contain;
	justify-self: center;
	align-self: center;

	width: 100%;
	height: 3.2em;

	@media (orientation: landscape) {
		height: 3.5em;
	}
`;

export const Text = styled.div`
	font-family: "Baloo";
	-webkit-text-stroke-width: 0.15em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	color: #fff;
	filter: drop-shadow(0 0.049em 0 #000);
	font-style: normal;
	font-weight: 400;
`;

export const RewardAmount = styled(Text)`
	font-size: 1.3em;
	line-height: 1em;
`;

export const Title = styled(Text)`
	margin-top: 2em;
	margin-bottom: 0.15em;
	font-size: 1.625em;
	line-height: 1em;
	font-weight: 400;
	width: 100%;
	//padding: 0 1.5em;
	text-align: center;

	@media (orientation: landscape) {
		margin-top: 1em;
		font-size: 2.125em;
		color: #fff;
	}
`;

export const SubTitle = styled.div`
	color: #333;
	font-family: "Inter";
	font-size: 1em;
	font-style: normal;
	font-weight: 700;
	line-height: 112.5%;
	text-align: center;
`;

export const OfferText = styled(Text)`
	width: 100%;
	margin-left: 0.5em;
	font-size: 0.9375em;
	line-height: 1.4em;
	display: flex;
	align-items: start;
	-webkit-text-stroke-width: 0.2em;

	@media (orientation: landscape) {
		font-size: 1.21em;
	}
`;

export const CustomButton = styled(Button)`
	width: 100%;
	margin-top: 0.8em;
	height: 3.562em;
	font-size: 1em;
	text-transform: none;

	@media (orientation: landscape) {
		width: 20em;
		margin-top: 1.7em;
	}
`;
